module.exports = __webpack_public_path__ + "img/领5元微信立减金.274c2e21.png";